import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@carnica/ui-kit';
import { getCookie, getMobileOS, setCookie } from '@beef/utils';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { useBreakpoints } from '@carnica/utils/hooks';
import { Container } from "../../../../components";
import { MOBILE_BANNER_COOKIE_NAME } from "./consts";
import { EHeaderTheme } from "../../store/slices/layout";
import { useClassOnScroll } from "../../hooks/useClassOnScroll";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var CloseIcon = function CloseIcon(params) {
  return /*#__PURE__*/React.createElement(IconCloseRoundStroked, _extends({}, params, {
    color: "secondary-invert",
    size: 20,
    "data-t-id": "components-MobileAppBanner"
  }));
};
export var MobileAppBanner = function MobileAppBanner(_ref) {
  var banner = _ref.banner,
    headerTheme = _ref.headerTheme,
    cookie = _ref.cookie,
    headers = _ref.headers;
  var bannerSubText = banner.bannerSubText,
    bannerText = banner.bannerText,
    buttonText = banner.buttonText,
    buttonHref = banner.buttonHref,
    logoSrc = banner.logoSrc,
    cookieDomain = banner.cookieDomain,
    ttl = banner.ttl;
  // Вычисляем, нужно ли показывать баннер: если cookie отсутствует и устройство Android

  var _useBreakpoints = useBreakpoints({
      xs: 360,
      s: 361
    }),
    _useBreakpoints2 = _slicedToArray(_useBreakpoints, 1),
    activePoint = _useBreakpoints2[0];
  var initialShowBanner = !cookie[MOBILE_BANNER_COOKIE_NAME] && getMobileOS(headers.userAgent) === 'android';
  var _useState = useState(initialShowBanner),
    _useState2 = _slicedToArray(_useState, 2),
    isShowBanner = _useState2[0],
    setIsShowBanner = _useState2[1];
  var bannerRef = useRef(null);
  useEffect(function () {
    if (!getCookie(MOBILE_BANNER_COOKIE_NAME) && getMobileOS() === 'android') {
      setIsShowBanner(true);
    } else {
      setIsShowBanner(false);
    }
  }, []);
  useClassOnScroll(bannerRef, cn('banner--hidden'));
  var handleClose = useCallback(function () {
    setIsShowBanner(false);
    setCookie({
      name: MOBILE_BANNER_COOKIE_NAME,
      value: 'shown',
      domain: cookieDomain,
      ttl: ttl
    });
  }, [cookieDomain, ttl]);
  if (!isShowBanner) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Container.Flex, {
    align: "center",
    "aria-hidden": !isShowBanner,
    className: cn('banner', "banner--".concat(headerTheme)),
    componentRef: bannerRef,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Container.Flex, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('close-button'),
    iconLeft: CloseIcon,
    mode: "inline",
    onClick: handleClose
  }), /*#__PURE__*/React.createElement("img", {
    alt: "\u043B\u043E\u0433\u043E\u0442\u0438\u043F \u0431\u0438\u043B\u0430\u0439\u043D",
    height: 40,
    src: logoSrc,
    width: 40
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('description')
  }, /*#__PURE__*/React.createElement(Text, {
    color: headerTheme === EHeaderTheme.dark ? 'primary-invert' : 'primary',
    variant: activePoint === 'xs' ? 'caption-medium' : 'body-small'
  }, bannerText), /*#__PURE__*/React.createElement(Text, {
    color: headerTheme === EHeaderTheme.dark ? 'primary' : 'tertiary',
    variant: activePoint === 'xs' ? 'caption-medium' : 'body-small'
  }, bannerSubText))), /*#__PURE__*/React.createElement(Button, {
    className: cn('button'),
    href: buttonHref,
    tagName: "a"
  }, /*#__PURE__*/React.createElement(Text, {
    tagName: "span",
    variant: "body-accent-small",
    "data-t-id": "components-MobileAppBanner"
  }, buttonText)));
};